import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Register() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    host_institution: "",
    username: "",
    password: "",
    confirmPassword: "",
  });
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    if (formData.password !== formData.confirmPassword) {
      setMessage("Passwords do not match.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch("/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password,
          first_name: formData.first_name || null,
          last_name: formData.last_name || null,
          email: formData.email || null,
          host_institution: formData.host_institution || null,
        }),
      });

      const result = await response.text();
      setMessage(result);
    } catch (error) {
      setMessage("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          background: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(20px)",
          borderRadius: "20px",
          padding: "3rem",
          boxShadow: "0 25px 50px rgba(0, 0, 0, 0.15)",
          border: "1px solid rgba(255, 255, 255, 0.3)",
          maxWidth: "450px",
          width: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background Pattern */}
        <div
          style={{
            position: "absolute",
            top: "-50%",
            right: "-50%",
            width: "200%",
            height: "200%",
            background: "radial-gradient(circle, rgba(0, 121, 192, 0.03) 0%, transparent 70%)",
            zIndex: 0,
          }}
        />
        <div style={{ position: "relative", zIndex: 1 }}>
          <div style={{ textAlign: "center", marginBottom: "2rem" }}>
            <img
              src="/logo.png"
              alt="SeizureBiomeDB Logo"
              style={{
                width: "80px",
                height: "auto",
                marginBottom: "1rem",
                borderRadius: "12px",
              }}
            />
            <h1
              style={{
                fontSize: "2rem",
                fontWeight: "700",
                color: "#0079C0",
                marginBottom: "0.5rem",
              }}
            >
              Join SeizureBiomeDB
            </h1>
            <p
              style={{
                color: "#6b7280",
                fontSize: "1rem",
                marginBottom: "2rem",
              }}
            >
              Create an account to access research data
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
          >
            {/* New profile fields */}
            <div>
              <label
                htmlFor="first_name"
                style={{ display: "block", marginBottom: "0.5rem", fontWeight: 600, color: "#374151", fontSize: "0.95rem" }}
              >
                First Name
              </label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                placeholder="Jane"
                style={{
                  width: "100%", padding: "1rem", borderRadius: "12px", border: "1px solid #d1d5db",
                  fontSize: "1rem", background: "white", transition: "all 0.3s ease",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
                onFocus={(e) => { e.target.style.borderColor = "#0079C0"; e.target.style.boxShadow = "0 0 0 3px rgba(0, 121, 192, 0.1)"; }}
                onBlur={(e) => { e.target.style.borderColor = "#d1d5db"; e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)"; }}
              />
            </div>

            <div>
              <label
                htmlFor="last_name"
                style={{ display: "block", marginBottom: "0.5rem", fontWeight: 600, color: "#374151", fontSize: "0.95rem" }}
              >
                Last Name
              </label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                placeholder="Doe"
                style={{
                  width: "100%", padding: "1rem", borderRadius: "12px", border: "1px solid #d1d5db",
                  fontSize: "1rem", background: "white", transition: "all 0.3s ease",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
                onFocus={(e) => { e.target.style.borderColor = "#0079C0"; e.target.style.boxShadow = "0 0 0 3px rgba(0, 121, 192, 0.1)"; }}
                onBlur={(e) => { e.target.style.borderColor = "#d1d5db"; e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)"; }}
              />
            </div>

            <div>
              <label
                htmlFor="email"
                style={{ display: "block", marginBottom: "0.5rem", fontWeight: 600, color: "#374151", fontSize: "0.95rem" }}
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="name@institution.edu"
                style={{
                  width: "100%", padding: "1rem", borderRadius: "12px", border: "1px solid #d1d5db",
                  fontSize: "1rem", background: "white", transition: "all 0.3s ease",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
                onFocus={(e) => { e.target.style.borderColor = "#0079C0"; e.target.style.boxShadow = "0 0 0 3px rgba(0, 121, 192, 0.1)"; }}
                onBlur={(e) => { e.target.style.borderColor = "#d1d5db"; e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)"; }}
              />
            </div>

            <div>
              <label
                htmlFor="host_institution"
                style={{ display: "block", marginBottom: "0.5rem", fontWeight: 600, color: "#374151", fontSize: "0.95rem" }}
              >
                Host Institution
              </label>
              <input
                type="text"
                id="host_institution"
                name="host_institution"
                value={formData.host_institution}
                onChange={handleChange}
                placeholder="University / Hospital / Company"
                style={{
                  width: "100%", padding: "1rem", borderRadius: "12px", border: "1px solid #d1d5db",
                  fontSize: "1rem", background: "white", transition: "all 0.3s ease",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
                onFocus={(e) => { e.target.style.borderColor = "#0079C0"; e.target.style.boxShadow = "0 0 0 3px rgba(0, 121, 192, 0.1)"; }}
                onBlur={(e) => { e.target.style.borderColor = "#d1d5db"; e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)"; }}
              />
            </div>

            {/* Existing fields */}
            <div>
              <label
                htmlFor="username"
                style={{ display: "block", marginBottom: "0.5rem", fontWeight: "600", color: "#374151", fontSize: "0.95rem" }}
              >
                Username
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "1rem",
                  borderRadius: "12px",
                  border: "1px solid #d1d5db",
                  fontSize: "1rem",
                  background: "white",
                  transition: "all 0.3s ease",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#0079C0";
                  e.target.style.boxShadow = "0 0 0 3px rgba(0, 121, 192, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#d1d5db";
                  e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)";
                }}
                placeholder="Choose a username"
              />
            </div>

            <div>
              <label
                htmlFor="password"
                style={{ display: "block", marginBottom: "0.5rem", fontWeight: "600", color: "#374151", fontSize: "0.95rem" }}
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "1rem",
                  borderRadius: "12px",
                  border: "1px solid #d1d5db",
                  fontSize: "1rem",
                  background: "white",
                  transition: "all 0.3s ease",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#0079C0";
                  e.target.style.boxShadow = "0 0 0 3px rgba(0, 121, 192, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#d1d5db";
                  e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)";
                }}
                placeholder="Create a password"
              />
            </div>

            <div>
              <label
                htmlFor="confirmPassword"
                style={{ display: "block", marginBottom: "0.5rem", fontWeight: "600", color: "#374151", fontSize: "0.95rem" }}
              >
                Confirm Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "1rem",
                  borderRadius: "12px",
                  border: "1px solid #d1d5db",
                  fontSize: "1rem",
                  background: "white",
                  transition: "all 0.3s ease",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#0079C0";
                  e.target.style.boxShadow = "0 0 0 3px rgba(0, 121, 192, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#d1d5db";
                  e.target.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)";
                }}
                placeholder="Confirm your password"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              style={{
                background: "linear-gradient(135deg, #0079C0 0%, #005f9e 100%)",
                color: "white",
                padding: "1rem",
                borderRadius: "12px",
                border: "none",
                fontSize: "1rem",
                fontWeight: "600",
                cursor: isLoading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 8px 25px rgba(0, 121, 192, 0.3)",
                opacity: isLoading ? 0.7 : 1,
              }}
            >
              {isLoading ? "Creating account..." : "Create Account"}
            </button>

            {message && (
              <div
                style={{
                  padding: "1rem",
                  borderRadius: "8px",
                  textAlign: "center",
                  fontWeight: "500",
                  fontSize: "0.95rem",
                  background: message.includes("submitted") || message.includes("successful")
                    ? "rgba(16, 185, 129, 0.1)"
                    : "rgba(239, 68, 68, 0.1)",
                  color: message.includes("submitted") || message.includes("successful")
                    ? "#10b981"
                    : "#ef4444",
                  border: `1px solid ${
                    message.includes("submitted") || message.includes("successful")
                      ? "#10b981"
                      : "#ef4444"
                  }`,
                }}
              >
                {message}
              </div>
            )}
          </form>

          <div
            style={{
              textAlign: "center",
              marginTop: "2rem",
              paddingTop: "1.5rem",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <p style={{ color: "#6b7280", fontSize: "0.9rem", marginBottom: "1rem" }}>
              Already have an account?
            </p>
            <Link
              to="/login"
              style={{
                color: "#0079C0",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "0.95rem",
                padding: "0.75rem 1.5rem",
                borderRadius: "8px",
                border: "2px solid rgba(0, 121, 192, 0.2)",
                transition: "all 0.3s ease",
                display: "inline-block",
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "rgba(0, 121, 192, 0.05)";
                e.target.style.borderColor = "rgba(0, 121, 192, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.borderColor = "rgba(0, 121, 192, 0.2)";
              }}
            >
              Sign In
            </Link>
          </div>

          <div
            style={{
              marginTop: "2rem",
              padding: "1rem",
              background: "rgba(59, 130, 246, 0.05)",
              borderRadius: "8px",
              border: "1px solid rgba(59, 130, 246, 0.2)",
            }}
          >
            <p style={{ fontSize: "0.85rem", color: "#374151", textAlign: "center", lineHeight: 1.5 }}>
              <strong>Note:</strong> New accounts require admin approval before you can access the system.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}